<template>
  <BaseLayout>
    <b-container>
      <div v-if="listing.length">
        <h5>Lugares onde o wispot te ajudou a se conectar.</h5>
        <br>
        <div class="text-right mb-100" >
          <div >
            <b-dropdown id="dropdownRevoke" text="Ação em massa" class="m-md-2 disabled">
              <b-dropdown-item @click="listRevokeSelected()" :disabled="!listLocationRevoke.length" id="revoke_location">Revogar acessos</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
        <AccessLocationItem v-for="accessLocation in listing" :access-location="accessLocation"
          :key="accessLocation.cgi_id" @locationList="listRevoke" />
      </div>

      <div v-else>
        <h5 v-show="loaded" class="text-center">Você ainda não utilizou o WISPOT</h5>
      </div>

    </b-container>

  </BaseLayout>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import BaseLayout from '@/components/BaseLayout'
import AccessLocationItem from '@/components/access-locations/AccessLocationItem'

export default {
  data() {
    return {
      loaded: false,
      listLocationRevoke: []
    }
  },
  components: {
    AccessLocationItem,
    BaseLayout
  },
  mounted() {
    try {
      this.ActionListing();
      this.loaded = true;
    } catch (ex) {
      console.log(ex);
    }
  },
  computed: {
    ...mapState('accessLocations', ['listing']),
  },
  methods: {
    ...mapActions('accessLocations', ['ActionListing']),
    ...mapActions('revoke', ['ActionRevokeAll']),


    listRevoke(checkBoxValue) {
      if (this.listLocationRevoke.includes(checkBoxValue.cgi_id)) {
        this.listLocationRevoke.splice(this.listLocationRevoke.indexOf(checkBoxValue.cgi_id), 1)
        return
      }
      this.listLocationRevoke.push(checkBoxValue.cgi_id)
    },

    listRevokeSelected() {
      let message = "Deseja revogar os acessos selecionados?"
      let options = {
        html: true,
        okText: 'Sim',
        cancelText: 'Não'
      }

      this.$dialog
        .confirm(message, options)
        .then(() => {
          this.ActionRevokeAll(this.listLocationRevoke).then(() => {
            this.ActionListing()
          })
        })
        .catch(err => {
          console.log(err)
        })
    },


  }
}
</script>